
import { Component, Vue } from 'vue-property-decorator';
import VueToast from 'vue-toasted';
import Form from '@/components/Form/Form.vue';
import { sendResetLeadRequest } from '@/utils/api';
import InputField from '@/types/InputField';
import * as constants from './constants';
import { TOAST_OPTIONS } from '@/utils/sharedOptions';

Vue.use(VueToast, TOAST_OPTIONS);

@Component({
  components: {
    Form,
  },
})

export default class ResetLeadForm extends Vue {
  public resetLeadInput: string = '';

  public constants: object = constants;
  public resetLeadError: null | string = null;
  public resetLeadFields: [InputField] = [{
    placeholder: constants.RESET_LEAD_PLACEHOLDER,
    updateInput: this.updateResetLeadInput,
    type: 'text',
    key: constants.RESET_LEAD_PLACEHOLDER,
  }];

  public updateResetLeadInput(input: string): void {
    this.resetLeadInput = input;
  }

  public async resetLead(): Promise<void> {
    this.resetLeadError = null;
    try {
      await sendResetLeadRequest(this.resetLeadInput);
      this.$toasted.show(constants.RESET_SUCCESSFULLY, TOAST_OPTIONS);
    } catch (error) {
      this.resetLeadError = error.message;
    }
  }

}
